import { Tool01 } from "@untitledui/icons";

interface WorkInProgressProps {
    title: string;
}

export function WorkInProgress({ title }: WorkInProgressProps) {
    return (
        <section className="border-secondary bg-primary flex flex-col items-center justify-center rounded-xl border px-8 py-16 text-center">
            <div className="bg-secondary text-fg-quaternary size-12 flex items-center justify-center rounded-full">
                <Tool01 className="size-6" />
            </div>
            <h2 className="text-primary mt-4 text-lg font-semibold">{title}</h2>
            <p className="text-tertiary mt-1 max-w-md text-sm">We're working on this section. It'll be available in an upcoming release.</p>
        </section>
    );
}
